<template>
  <div class="filter-container">
    <label>
      <input 
        type="radio" 
        name="isAccomplishedStatus" 
        v-model="isAccomplishedStatus" 
        v-on:change="updateFilter()" 
        value="All"/> {{$t("Webportal.AGGrid.Filter.All")}}
    </label>
    <label>
      <input 
        type="radio" 
        name="isAccomplishedStatus" 
        v-model="isAccomplishedStatus" 
        v-on:change="updateFilter()" 
        value="Accomplished"/> 
        <AccomplishmentIcon :isAccomplished="true" /> {{$t("Webportal.AGGrid.Filter.Accomplished")}}
    </label>
    <label>
      <input 
        type="radio"
        name="isAccomplishedStatus" 
        v-model="isAccomplishedStatus" 
        v-on:change="updateFilter()" 
        value="Not accomplished"/>
      <AccomplishmentIcon :isAccomplished="false" /> {{$t("Webportal.AGGrid.Filter.NotAccomplished")}}
    </label>
  </div>
</template>

<script>
import AccomplishmentIcon from "@/components/Shared/AccomplishmentIcon";
import jpath from 'jsonpath';

export default {
  components: {
    AccomplishmentIcon
  },
  data: function () {
    return {
      isAccomplishedStatus: 'All',
    };
  },
  methods: {
    updateFilter() {
      this.params.filterChangedCallback();
    },

    doesFilterPass(params) {
      let res = jpath.query(params.data, this.params.path);

      if(res && res[0] && res[0][0] && res[0][0].isAccomplished !== undefined) {
        switch(this.isAccomplishedStatus) {
          case "Accomplished": return res[0][0].isAccomplished == true;
          case "Not accomplished": return res[0][0].isAccomplished == false;
          default: return false;
        }
      } else {
        return false;
      }
    },

    isFilterActive() {
      return this.isAccomplishedStatus === 'Accomplished' || this.isAccomplishedStatus === 'Not accomplished';
    },

    // this example isn't using getModel() and setModel(),
    // so safe to just leave these empty. don't do this in your code!!!
    getModel() {},

    setModel() {},
  }
}
</script>

<style lang="scss">
  .filter-container {
    padding: 1rem;
    display: flex;
    flex-direction: column;
  }
</style>